module.exports = __webpack_public_path__ + "grootstatic/media/reliance-petroleum.9d7077aa.svg";